module.exports = __webpack_public_path__ + "fontawesome-webfont.674f50d287a8c48dc19b.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/fonts/fontawesome-webfont.eot?v=4.7.0
// module id = ../../../../../src/fonts/fontawesome-webfont.eot?v=4.7.0
// module chunks = 2